// A selectable "DOWNLOAD FOR <platform>" row.
import styles from "../Connect.module.css";
import { CheckIcon } from "./ConnectIcons";

export default function PlatformOption({ label, icon, selected, onSelect }) {
  return (
    <button
      type="button"
      className={`${styles.platformOption} ${selected ? styles.platformOptionOn : ""}`}
      onClick={onSelect}
      aria-pressed={selected}
    >
      <span className={styles.platformIcon}>{icon}</span>
      <span className={styles.platformText}>
        <span className={styles.platformKicker}>DOWNLOAD FOR</span>
        <span className={styles.platformLabel}>{label}</span>
      </span>
      {selected && <span className={styles.platformCheck}><CheckIcon size={16} /></span>}
    </button>
  );
}
